// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Navigation$PrezzeeRibbon from "../../common/Navigation/Navigation.bs.js";
import * as Navigation__Theme__Personal$PrezzeeRibbon from "./Navigation__Theme__Personal.bs.js";

var include = Navigation$PrezzeeRibbon.Component(Navigation__Theme__Personal$PrezzeeRibbon.Theme);

var Styles = include.Styles;

var Item = include.Item;

var make = include.make;

export {
  Styles ,
  Item ,
  make ,
}
/* include Not a pure module */
